import { Link } from 'react-router-dom';
import { DIRECTION_NAMES } from '../ResearchTheme';
import React, { useRef, useState, useEffect } from 'react';
import './index.scss';

import { textContent, newsCategory, experienceCategory, dataArtAwardCategory } from '../../../types/data.global';
import newIconUrl from '../../../assets/images/2-research/icon/new.svg';


import MyPanel from '../../MyPanel';
import PaperItem from '../../PaperItem';

import { Row, Col, Tabs } from 'antd';
import { TabsProps } from 'antd';
import { Image } from 'antd';

import _ from 'lodash';


interface ResearchAndNewsSectionProps {
}

const ResearchAndNewsSection: React.FC<ResearchAndNewsSectionProps> = (props) => {

    const researchColRef = useRef<HTMLDivElement>(null);
    const [researchColHeight, setResearchColHeight] = useState<number | undefined>(undefined);

    useEffect(() => {
      const el = researchColRef.current;
      if (!el) return;
      let rafId: number;
      const observer = new ResizeObserver(() => {
        // Defer the state update to the next frame so the ResizeObserver finishes
        // dispatching before we trigger another layout change. This avoids the
        // benign "ResizeObserver loop completed with undelivered notifications"
        // error that CRA's dev overlay surfaces as a fatal error.
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          setResearchColHeight(el.offsetHeight);
        });
      });
      observer.observe(el);
      return () => {
        cancelAnimationFrame(rafId);
        observer.disconnect();
      };
    }, []);

    const newsContentRef = useRef<HTMLDivElement>(null);
    const [showScrollHint, setShowScrollHint] = useState(false);

    useEffect(() => {
      const el = newsContentRef.current;
      if (!el) return;
      const scrollContainer = el.closest('.panel-body') as HTMLElement | null;
      if (!scrollContainer) return;

      const checkScroll = () => {
        const atBottom = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 8;
        setShowScrollHint(!atBottom);
      };

      let rafId: number;
      const onResize = () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(checkScroll);
      };

      const timer = setTimeout(checkScroll, 150);
      scrollContainer.addEventListener('scroll', checkScroll);
      const resizeObs = new ResizeObserver(onResize);
      resizeObs.observe(scrollContainer);

      return () => {
        clearTimeout(timer);
        cancelAnimationFrame(rafId);
        scrollContainer.removeEventListener('scroll', checkScroll);
        resizeObs.disconnect();
      };
    }, [researchColHeight]);

    // 2. Research Page
    const onChange = (key: string) => {
      console.log(key)
    }
    const researchTabElementList: TabsProps['items'] = []
    // the homepage shows selected papers only, grouped by the three research directions above (matched by title);
    // the full, filterable list is on the WHALES Lab page
    const SELECTED_GROUPS = [
      { title: DIRECTION_NAMES[0], papers: ['Figures as Interfaces', 'SciSciGPT'] },
      { title: DIRECTION_NAMES[1], papers: ['Funding the Frontier', 'InnovationInsights'] },
      { title: DIRECTION_NAMES[2], papers: ['Interaction-Augmented Instruction:', 'Situated and Dynamic Human-AI Communication'] },
    ];
    _.forEach(SELECTED_GROUPS, (group) => {
      const paperList = group.papers
        .map((t) => textContent.researchPage.find((paperItem) => paperItem.title.startsWith(t)))
        .filter((paperItem): paperItem is typeof textContent.researchPage[number] => !!paperItem)
      const paperElementList = paperList.map((paperInfo) => <PaperItem key={paperInfo.title} paper={paperInfo} />)
      researchTabElementList.push({
        key: group.title,
        label: group.title,
        children: paperElementList,
      })
    })

    // 3. News Page
    const newsTabElementList: TabsProps['items'] = []
    _.forEach(newsCategory, (category, index) => {
      const newsList = textContent.newsPage.filter((newsItem) => newsItem.category.includes(category))
      const newsElementList = newsList.map(newsInfo => {
        let linkElement = <></>
        if (newsInfo.link) {
          if (newsInfo.link.length > 1) {
            const linkList: JSX.Element[] = []
            _.forEach(newsInfo.link, (item) => linkList.push(<a href={item}>[Link]</a> ))
            linkElement = <div className='content'>
              {newsInfo.content}&nbsp;
              {newsInfo.location}&nbsp;
              {linkList}
            </div>
          } else {
            linkElement = <div className='content'>
              {newsInfo.content}&nbsp;@{newsInfo.location}. <a href={newsInfo.link[0]}>[Link]</a>
            </div>
          }
        } else {
          linkElement = <div className='content'>
            {newsInfo.content}&nbsp;
            {newsInfo.location}&nbsp;
          </div>
        }
        return (
          <div className='news-unit-div' key={index}>
            <div className='date'>
              {newsInfo.date}
              {(newsInfo as any).isNew && (
                <img src={newIconUrl} alt="new" style={{ height: '1.6em', verticalAlign: 'middle', marginLeft: '6px' }} />
              )}
            </div>
            {newsInfo.img &&
              <div className='news-teaser'>
                { (newsInfo.img).map(imgUrl =>
                    // <img src={imgUrl} alt='' />
                    <div className='img-div'>
                      <Image
                        src={imgUrl}
                        placeholder={
                          <Image
                            preview={false}
                            src={imgUrl}
                          />
                        }
                      />
                    </div>
                  )}
              </div>}
            {linkElement}
          </div>
        )
      })
      newsTabElementList.push({
        key: category,
        label: category,
        children: newsElementList,
      })
    })

  return (
    <div className='page-div' style={{width: '100%'}}>
      <Row justify="space-between" style={{width: '100%'}} className='page-div'>
      <Col xs={24} sm={24} md={16} lg={16} className='left-div'>
        <div ref={researchColRef}>
          <MyPanel viewTitle="SELECTED RESEARCH" width={''} height={'auto'} panelHeaderHeight={72}>
            <div style={{padding: 16}} id='researchPage'>
              <p className='research-full-note'>* indicates corresponding author; † indicates student under my supervision; ‡ indicates equal contribution. For the full list, see the <Link to='/whalesLab#publications'>WHALES Lab page</Link>.</p>
              {/* <div style={{marginBottom: '12px'}}>top general audience venues: <span style={{fontStyle: 'italic'}}>Nature</span> Computational Science</div>
              <div style={{marginBottom: '12px'}}>top hci/vis venues: CHI, VIS, TVCG</div> */}

              {researchTabElementList.map((group, i) => (
                <section className='research-group' key={group.key}>
                  <h3 className='research-group-title'><span>0{i + 1}</span>{group.label}</h3>
                  {group.children}
                </section>
              ))}
            </div>
          </MyPanel>
        </div>
      </Col>
      <Col xs={24} sm={24} md={7} lg={7} className='left-div news-col' style={{display: 'flex', flexDirection: 'column', position: 'relative'}}>
        <MyPanel viewTitle="NEWS" width={''} height={researchColHeight ? `${researchColHeight}px` : 'auto'} panelHeaderHeight={72} className='panel-scrollable'>
          <div style={{padding: 16}} id='newsPage' className='news-div' ref={newsContentRef}>
            <Tabs defaultActiveKey={newsCategory.IN2026} items={newsTabElementList} onChange={onChange} />
          </div>
        </MyPanel>
        <div className={`scroll-hint${showScrollHint ? ' visible' : ''}`}>
          <span className='scroll-hint-arrow'>↓</span>
        </div>
      </Col>
    </Row>
  </div>
)};

export default ResearchAndNewsSection;